import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import shallowEqual from "shallow-equal/objects";
import { resetEditFeatureChanges, setAttributes } from "../../../ducks/editFeature/editFeature";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";

export const useAttributesInHistory = (attributes: FeatureAttribute[], isEdit: boolean) => {
  const dispatch = useDispatch();
  const prevAttributes = useRef([]);

  useEffect(() => {
    if (!shallowEqualAttributes(prevAttributes.current, attributes)) {
      prevAttributes.current = attributes;
      dispatch(setAttributes(attributes));
    }
  }, [attributes]);

  useEffect(() => {
    if (!isEdit) {
      dispatch(setAttributes(prevAttributes.current));
      dispatch(resetEditFeatureChanges(true));
    }
  }, [isEdit]);
};

function shallowEqualAttributes(prevAttrs: FeatureAttribute[], currentAttrs: FeatureAttribute[]): boolean {
  if (currentAttrs.length !== prevAttrs.length) {
    return false;
  }

  return !currentAttrs.some((attribute, index) => !prevAttrs[index] || !shallowEqual(prevAttrs[index], attribute));
}
